<template>
    <div class="instructions">
        <div class="collapsed" @click="showText">
            <h3>Explanation</h3>
            <transition
            name="rotate"
            >
            <img :style="`transform: rotate(${rotation}deg);`" src="@/assets/dropdown.svg" alt="dropdown icon">
            </transition>
        </div>
        <div class="open" v-if="show">
            <br><p>You have been randomly assigned to a group: A or B. Each group was presented a <u>different first question: </u><br><br>
            "Do you think this room costs more than:" <br>
            Group A: €5000<br>
            Group B: €50<br><br>
            <u>This influenced then your answer in the second question:</u> “How much do you think this room costs?”.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Instructions',
    props: [],
    data() {
        return {
            show: false,
            rotation: 0,
        }
    },
    methods: {
        showText() {
            this.show = !this.show;
            if (this.rotation === 180) {
                this.rotation -= 180
            } else {
            this.rotation += 180;
            }
        },
    },
}
</script>

<style scoped>

.instructions {
    background-color: #00DDAB;
    padding: 10px 25px;
    border-radius: 6px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
}

.collapsed {
    display: flex;
    justify-content: space-between;
}

.open {
    margin-bottom: 20px;
}

.open p {
    margin: 5px 0;
}
</style>